import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { DxDataGridModule, DxTemplateModule } from 'devextreme-angular';
import { LoadunitDto, MasterdataService } from '../../../shared/generated/backend';
import { firstValueFrom, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContextService } from '../../../services/context.service';
import { RowDblClickEvent } from 'devextreme/ui/data_grid';
import { LoaderComponent } from '../../../loader/loader.component';
import { UtilsService } from '../../../services/utils.service';
import { ActivatedRoute } from '@angular/router';
import { LoadUnitRefreshService } from '../loadunit-context-view/loadunit-refresh.service';

@Component({
  selector: 'app-loadunit-list',
  imports: [SharedModule, DxDataGridModule, DxTemplateModule, LoaderComponent],
  templateUrl: './loadunit-list.component.html',
  styleUrl: './loadunit-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadunitListComponent implements OnInit, OnDestroy {
  readonly loadunits = signal(new Array<LoadunitDto>());
  _loadunits = new Array<LoadunitDto>();

  isLoading = signal(false);
  private readonly destroy$ = new Subject<void>();

  private masterdataService = inject(MasterdataService);
  private contextService = inject(ContextService);
  utilService = inject(UtilsService);
  private activatedRoute = inject(ActivatedRoute);
  private loadUnitRefreshService = inject(LoadUnitRefreshService);

  async ngOnInit() {
    this.activatedRoute.url.pipe(takeUntil(this.destroy$)).subscribe(async _ => {
      this.isLoading.set(true);
      this._loadunits = await firstValueFrom(this.masterdataService.getLoadunits());
      // if (this._loadunits && this._loadunits.length > 0) {
      //   const firstLoadunitId = this._loadunits[0].id;
      //   if (!this.contextService.openContextViews.some(view => view.includes('loadunits/loadunit'))) {
      //     this.contextService.openContextView(`masterdata/loadunits/loadunit/${firstLoadunitId}`, true);
      //   }
      // }
      this.showData();
      this.isLoading.set(false);
    });

    this.loadUnitRefreshService.refresh$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.refreshLoadUnits();
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showData() {
    this.loadunits.set(this._loadunits);
  }

  addLoadunit() {
    this.contextService.openContextView(`masterdata/loadunits/loadunit`);
  }

  async refreshLoadUnits() {
    this.isLoading.set(true);
    this._loadunits = await firstValueFrom(this.masterdataService.getLoadunits());
    this.showData();
    this.isLoading.set(false);
  }

  loadLoadunit(event: RowDblClickEvent) {
    this.contextService.openContextView(`masterdata/loadunits/loadunit/${event.data.id}`);
  }
}
